<!-- Breadcrumb -->
<div class="breadcrumb-card mb-25 d-md-flex align-items-center justify-content-between">
    <h5 class="mb-0">
        {{ 'Update_plant' | translate}}
    </h5>

    <ol class="breadcrumb list-unstyled mt-0 mb-0 pl-0">
        <li class="breadcrumb-item position-relative">
            <a routerLink="/plants/all-plant-list">{{ 'Plants_list' | translate}}</a>
        </li>

        <li class="breadcrumb-item position-relative">
            <a class="gap-icon" (click)="goBack()">
                <mat-icon class="back-icon">arrow_back</mat-icon>
                {{ 'Go_back' | translate }}
            </a>
        </li>

        <li class="breadcrumb-item position-relative">
            {{ 'Update_plant' | translate}}
        </li>
    </ol>
</div>

<mat-card class="daxa-card users-card mb-25 border-radius bg-white ">
    <form [formGroup]="personalForm">
        <div class="row">
            <div class="col-lg-12 col-md-12 col-sm-12">
                <div class="mb-20">
                    <label class="main-label d-block lh-1 text-black">
                        {{ 'Installation_date' | translate }}
                    </label>

                    <mat-form-field class="w-100 installation-date-field">

                        <mat-label>
                            {{ 'Select_installation_date' | translate }}
                        </mat-label>

                        <input matInput formControlName="installationDate" [matDatepicker]="installationDatePicker"
                            [max]="today" readonly placeholder="DD/MM/YYYY" (click)="installationDatePicker.open()" />

                        <button *ngIf="personalForm.get('installationDate')?.value" mat-icon-button matSuffix
                            type="button" class="clear-date-button" (click)="clearInstallationDate($event)">
                            <mat-icon>close</mat-icon>
                        </button>

                        <mat-datepicker-toggle matIconSuffix [for]="installationDatePicker">
                        </mat-datepicker-toggle>

                        <mat-datepicker #installationDatePicker startView="multi-year">
                        </mat-datepicker>

                        <mat-hint>
                            {{ 'Installation_date_optional' | translate }}
                        </mat-hint>

                    </mat-form-field>
                </div>
            </div>
            <div class="col-lg-6 col-md-6 col-sm-6">
                <div class="mb-20">
                    <label class="main-label d-block lh-1 text-black">
                        {{'Name' | translate}}
                    </label>
                    <mat-form-field>
                        <input readonly formControlName="plantOwner" matInput>
                    </mat-form-field>
                </div>
            </div>

            <div hidden class="col-lg-6 col-md-6 col-sm-6">
                <div class="mb-20">
                    <label class="main-label d-block lh-1 text-black">
                        UserId
                    </label>
                    <mat-form-field>
                        <mat-label>
                            Enter UserId
                        </mat-label>
                        <input formControlName="userId" matInput type="text" readonly>
                    </mat-form-field>
                </div>
            </div>

            <div class="col-lg-6 col-md-6 col-sm-6">
                <div class="mb-20">
                    <label class="main-label d-block lh-1 text-black">
                        {{'Email' | translate}}
                    </label>
                    <mat-form-field>
                        <mat-label>
                            {{'Enter email' | translate}}
                        </mat-label>
                        <input formControlName="email" matInput readonly>
                    </mat-form-field>
                </div>
            </div>

            <div class="col-lg-6 col-md-6 col-sm-6">
                <div class="mb-20">
                    <label class="main-label d-block lh-1 text-black">
                        {{'Phone_number' | translate}}
                    </label>
                    <mat-form-field>
                        <mat-label>
                            {{'Enter phone number' | translate}}
                        </mat-label>
                        <input [readonly]="isLocked" matInput placeholder="E.g. +123 452183" formControlName="phone"
                            type="tel">
                        <mat-error *ngIf="personalForm.get('phone')?.hasError('required')
                    && (personalForm.get('phone')?.touched || personalForm.get('phone')?.dirty)">
                            {{'Phone number is required' | translate}}
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>

            <div class="col-lg-6 col-md-6 col-sm-6">
                <div class="mb-20">
                    <label class="main-label d-block lh-1 text-black">
                        {{'Address' | translate}}
                    </label>
                    <mat-form-field>
                        <mat-label>
                            {{'Enter address' | translate}}
                        </mat-label>
                        <input [readonly]="isLocked" formControlName="address" matInput placeholder="E.g. Copenhagen">
                        <mat-error *ngIf="personalForm.get('address')?.hasError('required')
                    && (personalForm.get('address')?.touched || personalForm.get('address')?.dirty)">
                            {{'Address is required' | translate}}
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>

            <div class="col-lg-6 col-md-6 col-sm-6">
                <div class="mb-20">
                    <label class="main-label d-block lh-1 text-black">
                        {{'City' | translate}}
                    </label>
                    <mat-form-field class="w-full city-field">
                        <mat-label>{{'City' | translate}}</mat-label>
                        <input #cityInput [readonly]="isLocked" type="text" matInput required
                            [formControl]="citySearchCtrl" [matAutocomplete]="cityAuto"
                            placeholder="Type to search city" />
                        <button type="button" matSuffix class="add-city-btn" (click)="openAddCity($event)">
                            + {{'Add new city' | translate}}
                        </button>
                        <mat-autocomplete #cityAuto="matAutocomplete" (optionSelected)="onCityOptionSelected($event)">
                            <mat-option *ngFor="let c of filteredCities$ | async" [value]="c">
                                <div class="flex items-center justify-between w-full">
                                    <span>{{ c.title }}</span>
                                </div>
                            </mat-option>
                            <mat-option disabled *ngIf="(filteredCities$ | async)?.length === 0">No
                                results
                            </mat-option>
                        </mat-autocomplete>
                        <mat-hint *ngIf="selectedCity">{{'Time Zone' | translate}} : {{ selectedCity.timeZoneId
                            }}</mat-hint>
                        <mat-error *ngIf="personalForm.get('cityId')?.hasError('required')">{{'City is required' |
                            translate}}</mat-error>
                        <mat-error *ngIf="personalForm.get('cityId')?.hasError('cityMismatch')">{{'Please pick a city
                            from the list' | translate}}</mat-error>
                        <mat-error *ngIf="personalForm.get('cityId')?.hasError('timezoneMissing')">{{'Selected city has
                            no time zone' | translate}}</mat-error>
                    </mat-form-field>
                    <input [readonly]="isLocked" required type="hidden" formControlName="cityId">
                </div>
            </div>

            <div class="col-lg-6 col-md-6 col-sm-6">
                <div class="mb-20">
                    <label class="main-label d-block lh-1 text-black">
                        {{'Username' | translate}}
                    </label>
                    <mat-form-field>
                        <mat-label>
                            {{'Enter username' | translate}}
                        </mat-label>
                        <input formControlName="username" matInput readonly>
                    </mat-form-field>
                </div>
            </div>

            <div class="col-lg-6 col-md-6 col-sm-6">
                <div class="mb-20">
                    <label class="main-label d-block lh-1 text-black">
                        {{'Low_price_threshold' | translate}}
                    </label>
                    <mat-form-field>
                        <mat-label>
                            {{'Enter low price threshold' | translate}}
                        </mat-label>
                        <input [readonly]="isLocked" step="0.01" type="number" formControlName="lowPriceThreshold"
                            matInput>
                        <mat-error *ngIf="personalForm.get('lowPriceThreshold')?.hasError('required')">
                            {{'Low price threshold is required' | translate}}
                        </mat-error>
                        <span class="DDKspan" matSuffix>DKK</span>
                        <mat-hint>
                            {{'The affordability threshold for each customer,Prices below this threshold are considered
                            cheap.' | translate}}
                        </mat-hint>
                    </mat-form-field>
                </div>
            </div>

            <div class="col-lg-6 col-md-6 col-sm-6">
                <div class="mb-20">
                    <label class="main-label d-block lh-1 text-black">
                        {{'Customer_type' | translate}}
                    </label>

                    <mat-form-field class="w-full">
                        <mat-label>{{'Customer_type' | translate}}</mat-label>
                        <mat-select formControlName="customerType" placeholder="Select customer type" required>
                            <mat-option *ngFor="let c of customerTypeOptions" [value]="c">
                                {{ c }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>

                    <mat-error *ngIf="personalForm.get('customerType')?.hasError('required')
                  && (personalForm.get('customerType')?.touched || personalForm.get('customerType')?.dirty)">
                        {{'Customer type is required' | translate}}
                    </mat-error>
                </div>
            </div>

            <div class="col-lg-6 col-md-6 col-sm-6">
                <div class="mb-20">
                    <label class="main-label d-block lh-1 text-black">
                        {{'Price_class' | translate}}
                    </label>
                    <mat-form-field class="w-full">
                        <mat-label>{{ 'Price_class' | translate}}</mat-label>
                        <mat-select formControlName="priceClass" placeholder="Select price class">
                            <mat-option *ngFor="let pc of priceClass" [value]="pc.priceClass">
                                {{ pc.priceClass }}
                            </mat-option>
                        </mat-select>
                        <mat-error *ngIf="personalForm.get('priceClass')?.hasError('required')
                    && (personalForm.get('priceClass')?.touched || personalForm.get('priceClass')?.dirty)">
                            {{'Price class is required' | translate}}
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>

            <div class="col-lg-6 col-md-6 col-sm-6">
                <app-plant-location-component formControlName="location" [editable]="!isLocked">
                </app-plant-location-component>
            </div>

            <div class="col-lg-12 col-md-12 col-sm-12">
                <app-reference-ids formControlName="externalReferences" [serviceNames]="externalServiceNames">
                </app-reference-ids>
            </div>

            <div class="col-lg-12 col-md-6 col-sm-6">
                <label class="field-label">{{'Plant image' | translate}}</label>
                <app-upload-plant-image (fileHandleReady)="onFileHandleReady($event)"
                    (imageUploaded)="onImageUploaded($event)">
                </app-upload-plant-image>
            </div>
        </div>

        <div>
            <button mat-flat-button class="daxa" [disabled]="loading || personalForm.invalid"
                (click)="onClickUpdatePlant()">
                {{ isSubmitting ? ('Waiting ...' | translate) : ('Update_plant' | translate) }}
            </button>
        </div>
    </form>
</mat-card>